// 【更新】types/index.tsからStaff型とMember型をインポート
import { Staff, Member } from '../types';

export interface AuthState {
  staff: Staff | null;
  sessionToken: string | null;
  loading: boolean;
}

// 会員認証用の状態型
export interface MemberAuthState {
  member: Member | null;
  token: string | null;
  loading: boolean;
}

// ==================== スタッフ用セッション管理 ====================

// Session storage helpers
export const saveSession = (sessionToken: string, staff: Staff) => {
  sessionStorage.setItem('sessionToken', sessionToken);
  sessionStorage.setItem('staff', JSON.stringify(staff));
};

export const loadSession = (): { sessionToken: string | null; staff: Staff | null } => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  const staffData = sessionStorage.getItem('staff');
  
  return {
    sessionToken,
    staff: staffData ? JSON.parse(staffData) : null,
  };
};

export const clearSession = () => {
  sessionStorage.removeItem('sessionToken');
  sessionStorage.removeItem('staff');
};

// ==================== 会員用セッション管理 ====================

/**
 * 会員のセッションを保存する
 * @param token JWTトークン
 * @param member 会員情報
 */
export const saveMemberSession = (token: string, member: Member) => {
  localStorage.setItem('memberToken', token);
  localStorage.setItem('member', JSON.stringify(member));
};

/**
 * 会員のセッションを読み込む
 * @returns トークンと会員情報
 */
export const loadMemberSession = (): { token: string | null; member: Member | null } => {
  const token = localStorage.getItem('memberToken');
  const memberData = localStorage.getItem('member');
  
  return {
    token,
    member: memberData ? JSON.parse(memberData) : null,
  };
};

/**
 * 会員のセッションをクリアする
 */
export const clearMemberSession = () => {
  localStorage.removeItem('memberToken');
  localStorage.removeItem('member');
};